import Vue from "vue";
import commonService from "./common";
import initService from "@/common/api-services/init-service";
import sessionIdDirective from "@/common/directive/sessionId-directive";
import AuthService from "@/common/api-services/auth-service";
import corutils from "@/common/coreutils";

let baseurl = "";
  if(process.env.VUE_APP_CONFIG_ESIM_BASEURL == undefined){
    baseurl = process.env.VUE_APP_CONFIG_BASEURL
  }else {
    baseurl = process.env.VUE_APP_CONFIG_ESIM_BASEURL
  };
let apikey = `${process.env.VUE_APP_CONFIG_APIKEY}`;
let userName = initService.getUserNameInfo();
let customer = initService.getCustomerInfo();
let group = initService.getGroupInfo();
let pId = sessionIdDirective.getJSessionId();
let headers = {
  headers: {
    "Content-Type": "application/json",
    "x-api-key": apikey,
  },
};

const administratorService = {

  //NOTE: This page uses the customer Administrator to allow registration for Admin functions.

  getPortalSettings(){
    let url = `${baseurl}?method=ADMIN_GetPortalSettings&auth=1&user=${userName}`;
        return Vue.axios.get(url, headers)
    .then((res) => {
      return res.data.message;
    })
    .catch((error) => {
      throw error;
    });

  },

  async setPortalSettings(newRow){
    let url = `${baseurl}?method=ADMIN_SetPortalSettings&auth=1&newRow=${newRow}`;
        return Vue.axios.get(url, headers)
    .then((res) => {
      return res.data.message;
    })
    .catch((error) => {
      throw error;
    });

  },

  async updatePortalSettings(id,updateRow){
    let url = `${baseurl}?method=ADMIN_UpdatePortalSettings&auth=1&id=${id}&updateRow=${updateRow}`;
    return Vue.axios.get(url, headers)
      .then(response => response.data.message)
      .catch(error => console.error(error))
  },

  async deletePortalSettings(id){
    let url = `${baseurl}?method=ADMIN_DeletePortalSettings&auth=1&id=${id}`;
        return Vue.axios.get(url, headers)
    .then((res) => {
      return res.data.message;
    })
    .catch((error) => {
      throw error;
    });

  },

  async getCustomerList() {
    let url = `${baseurl}?method=IOT_GetCustomerInfoList&auth=1`;
        return Vue.axios.get(url, headers)
    .then((res) => {
      return res.data.message;
    })
    .catch((error) => {
      throw error;
    });

  },

  async getGroupList(expireCache=false) {
    let url = `${baseurl}?method=IOT_GetGroupList&auth=1`;
        return Vue.axios.get(url, headers)
    .then((res) => {
      return res.data.message;
    })
    .catch((error) => {
      throw error;
    });

  },

  async getUserList() {
    let url = `${baseurl}?method=IOT_GetUserList&auth=1`;
        return Vue.axios.get(url, headers)
    .then((res) => {
      return res.data.message;
    })
    .catch((error) => {
      throw error;
    });

  },

  async registerUser(data) {
    let url = `${baseurl}?method=IOT_Register&data=${data}&auth=1&user=${userName}`;
    return Vue.axios.get(url, headers)
        .then((res) => {
          AuthService.setActivityLog('AUTH:IOT_Register[USER PROFILE]', 'IOT_Register OK', 0);
          return res.data.message;
        })
        .catch((err) => {
          AuthService.setActivityLog('AUTH:IOT_Register[USER PROFILE]', err.message, 1);
          throw err;
        });
  },

  async addCustomer(customerForm) {
    let {customerGroup, companyName, address1, address2, city, state, country, contactPerson, zipCode, phoneNo, email} = customerForm;
    let url = `${baseurl}?method=IOT_AddCustomerInfo&customer_group=${customerGroup}&company_name=${companyName}&address1=${address1}&address2=${address2}&city=${city}&state=${state}&country=${country}&zipcode=${zipCode}&contact_name=${contactPerson}&contact_phone=%2B${phoneNo}&contact_email=${email}&auth=1&user=${userName}`;
    return Vue.axios.get(url, headers)
        .then((response) => {
          AuthService.setActivityLog('AUTH:addCustomer[USER PROFILE]', 'addCustomer OK', 0);
          return response;
        })
        .catch((error) => {
          AuthService.setActivityLog('AUTH:addCustomer[USER PROFILE]', error.message, 1);
          throw error;
        });
  },

  async updateCustomer(identifier, customerForm) {
    let {customerGroup, companyName, address1, address2, city, state, country, contactPerson, zipCode, phoneNo, email} = customerForm;
    let url = `${baseurl}?method=IOT_UpdateCustomerInfo&customer_id=${identifier}&customer_group=${customerGroup}&company_name=${companyName}&address1=${address1}&address2=${address2}&city=${city}&state=${state}&country=${country}&zipcode=${zipCode}&contact_name=${contactPerson}&contact_phone=%2B${phoneNo}&contact_email=${email}&auth=1&user=${userName}`;
    return Vue.axios.get(url, headers)
        .then((response) => {
          AuthService.setActivityLog('AUTH:updateCustomer[USER PROFILE]', 'updateCustomer OK', 0);
          return response;
        })
        .catch((error) => {
          AuthService.setActivityLog('AUTH:updateCustomer[USER PROFILE]', error.message, 1);
          throw error;
        });
  },

  async deleteCustomer(customerId) {
    let url = `${baseurl}?method=IOT_DeleteCustomer&customer_id=${customerId}&auth=1&user=${userName}`;
    return Vue.axios.get(url, headers)
        .then((response) => {
          AuthService.setActivityLog('AUTH:deleteCustomer[USER PROFILE]', 'deleteCustomer OK', 0);
          return response;
        })
        .catch((error) => {
          AuthService.setActivityLog('AUTH:deleteCustomer[USER PROFILE]', error.message, 1);
          throw error;
        });
  },

  async createGroup(group) {
    let url = `${baseurl}?method=IOT_CreateGroup&groupname=${group.groupName}&description=${group.description}&auth=1&user=${userName}`;
    return Vue.axios.get(url, headers)
        .then((response) => {
          AuthService.setActivityLog('AUTH:createGroup[USER PROFILE]', 'createGroup OK', 0);
          return response;
        })
        .catch((error) => {
          AuthService.setActivityLog('AUTH:createGroup[USER PROFILE]', error.message, 1);
          throw error;
        });
  },

  async deleteGroup(groupname) {
    let url = `${baseurl}?method=IOT_DeleteGroup&groupname=${groupname}&auth=1&user=${userName}`;
    return Vue.axios.get(url, headers)
        .then((response) => {
          AuthService.setActivityLog('AUTH:deleteGroup[USER PROFILE]', 'deleteGroup OK', 0);
          return response;
        })
        .catch((error) => {
          AuthService.setActivityLog('AUTH:deleteGroup[USER PROFILE]', error.message, 1);
          throw error;
        });
  },

  async updateUserProfile(username, attr) {
    //FORMAT attr as url encoded.
    // console.log(userName, '=.')
    attr = encodeURIComponent(JSON.stringify(attr));
    let url = `${baseurl}?method=IOT_AdminUpdateUserAttributes&username=${username}&userAttributes=${attr}&auth=1&user=${userName}`;
    return Vue.axios.get(url, headers)
        .then((response) => {
          AuthService.setActivityLog('AUTH:updateUserProfile[USER PROFILE]', 'updateUserProfile OK', 0);
          return response;
        })
        .catch((error) => {
          AuthService.setActivityLog('AUTH:updateUserProfile[USER PROFILE]', error.message, 1);
          throw error;
        });
  },

  async resetUserPassword(username, password) {
    let url = `${baseurl}?method=IOT_AdminSetUserPassword&username=${username}&password=${password}&auth=1&user=${userName}`;
    return Vue.axios.get(url, headers)
        .then((response) => {
          AuthService.setActivityLog('AUTH:resetUserPassword[USER PROFILE]', 'resetUserPassword OK', 0);
          return response;
        })
        .catch((error) => {
          AuthService.setActivityLog('AUTH:resetUserPassword[USER PROFILE]', error.message, 1);
          throw error;
        });
  },

  async removeUserFromGroup(username, groupname) {
    let url = `${baseurl}?method=IOT_RemoveUserToGroup&username=${username}&groupname=${groupname}&auth=1&user=${userName}`;
    return Vue.axios.get(url, headers)
        .then((response) => {
          AuthService.setActivityLog('AUTH:removeUserFromGroup[USER PROFILE]', 'removeUserFromGroup OK', 0);
          return response;
        })
        .catch((error) => {
          AuthService.setActivityLog('AUTH:removeUserFromGroup[USER PROFILE]', error.message, 1);
          throw error;
        });
  },

  async addUserToGroup(username, groupname) {
    let url = `${baseurl}?method=IOT_AddUserToGroup&username=${username}&groupname=${groupname}&auth=1&user=${userName}`;
    return Vue.axios.get(url, headers)
        .then((response) => {
          AuthService.setActivityLog('AUTH:addUserToGroup[USER PROFILE]', 'addUserToGroup OK', 0);
          return response;
        })
        .catch((error) => {
          AuthService.setActivityLog('AUTH:addUserToGroup[USER PROFILE]', error.message, 1);
          throw error;
        });
  },

  async deleteUser(username) {
    let url = `${baseurl}?method=IOT_DeleteUser&username=${username}&auth=1&user=${userName}`;
    return Vue.axios.get(url, headers)
        .then((response) => {
          AuthService.setActivityLog('AUTH:deleteUser[USER PROFILE]', 'deleteUser OK', 0);
          return response;
        })
        .catch((error) => {
          AuthService.setActivityLog('AUTH:deleteUser[USER PROFILE]', error.message, 1);
          throw error;
        });
  },

  async getTopOffPayments(start, end, msisdn, transId) {
    let url = `${baseurl}?method=IOT_SearchPayments&msisdn=${msisdn}&transaction_id=${transId}&start_date=${start}&end_date=${end}`;
    return Vue.axios.get(url, headers)
      .then(response => response.data.message)
      .catch(error => console.error(error))
  },

  async getTopOffPlans() {
    let url = `${baseurl}?method=getTopOffPlans`;
    return Vue.axios.get(url, headers)
      .then(response => response.data.message)
      .catch(error => console.error(error))
  },

  async addTopOffPlan(method, data) {
    let {type, name, description, price, speed, quota, expires, amount, units} = data;
    let url = `${baseurl}?method=${method}&type=${type}&name=${name}&description=${description}&price=${price}&speed=${speed}&quota=${quota}&expires=${expires}&amount=${amount}&units=${units}`;
    return commonService.commonAPI(encodeURI(param))
      .then(response => response.data.message)
      .catch(error => console.error(error))
  },

  async deleteTopOffPlan(id) {
    let url = `${baseurl}?method=deleteTopOffPlans&id=${id}`;
    return Vue.axios.get(url, headers)
      .then(response => response.data.message)
      .catch(error => console.error(error))
  },

  async getMobileDataPlans() {
    let url = `${baseurl}?method=getDataPlans`;
    return Vue.axios.get(url, headers)
      .then(response => response.data.message)
      .catch(error => console.error(error))
  },

  async addDataPlans(data) {
    let {name, description, price, unit, recurringPeriod, startPeriod, endPeriod, serverPeriod} = data;
    let url = `${baseurl}?method=IOT_AddDataPlans&name=${name}&description=${description}&price_type=${price}&uom=${unit}&recurring_charge_period=${recurringPeriod}&validForStartDt=${encodeURIComponent(startPeriod)}&validForEndDt=${encodeURIComponent(endPeriod)}&redirectServer=${serverPeriod}`;
    return Vue.axios.get(url, headers)
      .then(response => response.data.message)
      .catch(error => console.error(error))
  },

  async deleteDataPlan(id) {
    let url = `${baseurl}?method=IOT_DeleteDataPlans&id=${id}&nocache=1`;
    return Vue.axios.get(url, headers)
      .then(response => response.data.message)
      .catch(error => console.error(error))
  },

  async getMobilePlanAndBalance(msisdn) {
    let url = `${baseurl}?method=getCurrentPlanAndBalance&msisdn=${msisdn}&units=MB`;
    return Vue.axios.get(url, headers)
      .then(response => response.data.message)
      .catch(error => console.error(error))
  },

  async getDataPlans() {
    let url = `${baseurl}?method=IOT_TopOffPlans&nocache=1`;
    return Vue.axios.get(url, headers)
      .then(response => response.data.message)
      .catch(error => console.error(error))
  },

  async addTopOffOCS(method, data) {
    let {msisdn, dataPlan} = data;
    let url = `${baseurl}?method=${method}&msisdn=${msisdn}&amount=${dataPlan}&units=MB`;
    return Vue.axios.get(url, headers)
      .then(response => response.data.message)
      .catch(error => console.error(error))
  },

  async deleteBuckets(msisdn) {
    let url = `${baseurl}?method=IOT_DeleteBuckets&msisdn=${msisdn}&nocache=1`;
    return Vue.axios.get(url, headers)
      .then(response => response.data.message)
      .catch(error => console.error(error))
  },

  async getDslDataPlan() {
    let url = `${baseurl}?method=getDslDataPlans&nocache=1`;
    return Vue.axios.get(url, headers)
      .then(response => response.data.message)
      .catch(error => console.error(error))
  },

  async deleteDslDataPlan(name) {
    let url = `${baseurl}?method=deleteDslDataPlans&plan_name=${name}`;
    return Vue.axios.get(url, headers)
      .then(response => response.data.message)
      .catch(error => console.error(error))
  },

  async addDslDataPlans(data) {
    let {planName, planSpeed, interval} = data
    let url = `${baseurl}?method=addDslDataPlans&plan_name=${planName}&plan_speed=${encodeURIComponent(planSpeed)}&update_interval=${interval}`;
    return Vue.axios.get(url, headers)
      .then(response => response.data.message)
      .catch(error => console.error(error))
  },

  async getDslPlanAndBalance(address) {
    let url = `${baseurl}?method=getDslPlanAndBalance&macaddress=${encodeURIComponent(address)}&units=GB`;
    return Vue.axios.get(url, headers)
      .then(response => response.data.message)
      .catch(error => console.error(error))
  },

  async getDslDataPlans() {
    let url = `${baseurl}?method=getDslDataPlans&type=INT&nocache=1`;
    return Vue.axios.get(url, headers)
      .then(response => response.data.message)
      .catch(error => console.error(error))
  },

  async setDslPlanAndBalance(macaddress, amount, plan_name) {
    let url = `${baseurl}?method=setDslPlanAndBalance&macaddress=${macaddress}&units=GB&amount=${amount}&plan_name=${plan_name}&nocache=1`;
    return Vue.axios.get(url, headers)
      .then(response => response.data.message)
      .catch(error => console.error(error))
  },

  async delDslPLanAndBalance(macAddress) {
    let url = `${baseurl}?method=delDslPLanAndBalance&macaddress=${macAddress}&nocache=1`;
    return Vue.axios.get(url, headers)
      .then(response => response.data.message)
      .catch(error => console.error(error))
  },

  async getDslTopOffPlans() {
    let url = `${baseurl}?method=getTopOffPlans&type=INT&nocache=1`;
    return Vue.axios.get(url, headers)
      .then(response => response.data.message)
      .catch(error => console.error(error))
  },

  async setDslTopOff(data) {
    let {address, dataPlan} = data
    let url = `${baseurl}?method=setDslTopOff&macaddress=${address}&units=GB&amount=${dataPlan}&nocache=1`;
    return Vue.axios.get(url, headers)
      .then(response => response.data.message)
      .catch(error => console.error(error))
  },

  async getTowerList() {
    let url = `${baseurl}?method=IOT_GetTowersList&mcc=316&limit=50&nocache=1`;
    return Vue.axios.get(url, headers)
      .then(response => response.data.message)
      .catch(error => console.error(error))
  },

  async getTowerRadioList() {
    let url = `${baseurl}?method=IOT_GetRadios&nocache=1`;
    return Vue.axios.get(url, headers)
      .then(response => response.data.message)
      .catch(error => console.error(error))
  },

  async addTower(method, data) {
    let {radioAccess, countryCode, networkCode, areaCode, cellId, latitude, longitude } = data;
    let url = `${baseurl}?method=${method}&radio=${radioAccess}&mcc=${countryCode}&mnc=${networkCode}&lac=${areaCode}&cell=${cellId}&lat=${latitude}&lon=${longitude}`;
    return Vue.axios.get(url, headers)
      .then(response => response.data.message)
      .catch(error => console.error(error))
  },

  async deleteTower(id) {
    let url = `${baseurl}?method=IOT_DeleteTower&id=${id}&nocache=1`;
    return Vue.axios.get(url, headers)
      .then(response => response.data.message)
      .catch(error => console.error(error))
  },

  /**
   * Adds a new item to the ilr inventory table (mns_subscriber/portal_subscriber)
   * @param item
   */
  async importTemplate(item) {
     baseurl = `${process.env.VUE_APP_CONFIG_BASEURL}`;
     let data = {
       data: item
     };
     //todo: we should change this to a post for future api
    let url = `${baseurl}?method=IOT_AddInventory&nocache=1&item=`+corutils.base64_encode(JSON.stringify(data));
    return Vue.axios.get(url, headers)
        .then(response => response.data.message)
        .catch(error => console.error(error));
  },
};

export default administratorService;
